import { useQuery } from 'react-query';

import { getQuestionLinks } from 'App/services/AssessmentQuestionService';

function useFetchAssessmentQuestionLinks(assessmentId) {
    return useQuery(['assessmentId', assessmentId, 'questions', 'links'], () => getQuestionLinks(assessmentId), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchAssessmentQuestionLinks;
